import { render } from "./UCTimePicker.vue?vue&type=template&id=5bc922f9&scoped=true"
import script from "./UCTimePicker.vue?vue&type=script&lang=js"
export * from "./UCTimePicker.vue?vue&type=script&lang=js"

import "./UCTimePicker.vue?vue&type=style&index=0&id=5bc922f9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc922f9"]])

export default __exports__